import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  setLanguage,
  setSelectedRegion,
} from '@app/redux/localization/actions';

import { setShowWhereAreYouModal } from '@app/redux/ui/actions';

import {
  Categories,
  Events as GoogleAnalyticsEvents,
  useGATrackEvent,
} from '@app/analytics';

const useFormActions = () => {
  const dispatch = useDispatch();
  const trackGAEvent = useGATrackEvent();

  const dispatchSetShowWhereAreYouModal = useCallback(
    (showWhereAreYouModal, dismissed, banner) =>
      dispatch(
        setShowWhereAreYouModal(showWhereAreYouModal, dismissed, banner),
      ),
    [dispatch],
  );

  const dispatchSetLanguage = useCallback(
    ({ language, url, code, urlPrefix, currency }) =>
      dispatch(setLanguage({ language, url, code, urlPrefix, currency })),
    [dispatch],
  );

  const dispatchSetRegion = useCallback(
    ({ selectedRegion }) => dispatch(setSelectedRegion({ selectedRegion })),
    [dispatch],
  );

  const saveSettings = useCallback(
    ({ updatedRegion, updatedLanguage }) => {
      dispatchSetLanguage({
        language: updatedLanguage.display,
        url: updatedLanguage.url,
        code: updatedLanguage.value,
        urlPrefix: updatedLanguage.urlPrefix,
        currency: updatedRegion.preferredCurrency,
      });

      dispatchSetRegion({ selectedRegion: updatedRegion.value });

      trackGAEvent(
        GoogleAnalyticsEvents.LocationBannerSettingsUpdated,
        Categories.LocationModal,
        `Language: ${updatedLanguage.value}, Region: ${updatedRegion.value}, Currency: ${updatedRegion.preferredCurrency}`,
      );

      dispatchSetShowWhereAreYouModal(false, false, true);
    },
    [
      dispatchSetLanguage,
      dispatchSetRegion,
      dispatchSetShowWhereAreYouModal,
      trackGAEvent,
    ],
  );

  return {
    saveSettings,
    dispatchSetShowWhereAreYouModal,
  };
};

export default useFormActions;
